import { getApiBaseUrl } from '../config/api';

export async function lookupBooking({ confirmationCode, email }) {
  const baseUrl = getApiBaseUrl();
  if (!baseUrl) {
    throw new Error('API is not configured.');
  }

  const response = await fetch(`${baseUrl.replace(/\/$/, '')}/bookings/lookup`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ confirmationCode, email }),
  });

  const data = await response.json().catch(() => ({}));
  if (!response.ok) {
    throw new Error(data.error || 'Invalid code or email.');
  }

  return data.booking;
}
